import React, { useRef } from "react";
import { useDrag, useDrop } from 'react-dnd';
import { MenuDotsSvg, SwitchSvg, EditPencilSvg, TechnicianSvg, StoreSvg, UserSvg, TrashBinSvg } from "components/icons";
import { SecondaryTextSmBold, SecondaryTextXs } from "components/atoms";
import styled, { css } from "styled-components";
import { getObjectIcons } from 'utils';
import { titleize } from "utils";

const Row = styled.tr`
  ${({ active, isDragging, theme }) => css`
    border-bottom: 1px solid #e3e3e3;
    height: 70px;
    opacity: ${active || isDragging ? 1 : .5};

    background-color: ${isDragging ? `${theme?.colour?.primary ?? '#1DBD6B'}26` : ''};
  `}
`;

export const SwitchField = ({ remove, id, name, active, type, toggle, move, index, save, is_removable, icon_name, onEdit, can_be_assigned_to_admin, can_be_assigned_to_tech, can_be_assigned_to_vendor, loadingCards }) => {
  const ref = useRef(null);
  const [{ handlerId }, drop] = useDrop({
    accept: 'card',
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) {
        return;
      }
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      move(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
    drop() {
      save();
    }
  });

  const [{ isDragging }, drag] = useDrag({
    type: 'card',
    item: () => {
      return { name, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  drag(drop(ref));

  return (
    <Row active={active} ref={ref} data-handler-id={handlerId} isDragging={isDragging}>
      <td>
        <div className="flex items-center">
          <div className="cursor-move mr-1">
            <MenuDotsSvg multiple />
          </div>
          <div className="mr-2">
            {getObjectIcons({ color: window?.settings?.primary_color ?? '#1DBD6B', width: 12, height: 12 })[icon_name]}
          </div>
          <SecondaryTextSmBold>
            {name === 'Maintenance Sign Off' ? 'Maintenance Complete' : name}
          </SecondaryTextSmBold>
        </div>
      </td>
      <td>
        <SecondaryTextXs>
          {titleize(type ?? '')}
        </SecondaryTextXs>
      </td>
      <td>
        <div className="flex items-center">
          <div style={{ width: 88, marginRight: 16 }}>
            {can_be_assigned_to_tech &&
              <div className="flex items-center">
                <div className="mr-2">
                  <TechnicianSvg width={12} height={12} color={window?.settings?.secondary_color} />
                </div>
                <SecondaryTextXs>
                  Technician
                </SecondaryTextXs>
              </div>
            }
          </div>
          <div style={{ width: 63, marginRight: 16 }}>
            {can_be_assigned_to_vendor &&
              <div className="flex items-center mr-4">
                <div className="mr-2">
                  <StoreSvg width={12} height={12} color={window?.settings?.secondary_color} />
                </div>
                <SecondaryTextXs>
                  Vendor
                </SecondaryTextXs>
              </div>
            }
          </div>
          <div style={{ width: 60, marginRight: 16 }}>
            {can_be_assigned_to_admin &&
              <div className="flex items-center mr-4">
                <div className="mr-2">
                  <UserSvg width={12} height={12} color={window?.settings?.secondary_color} />
                </div>
                <SecondaryTextXs>
                  Admin
                </SecondaryTextXs>
              </div>
            }
          </div>
        </div>
      </td>
      <td>
        <div className="flex items-center">
          <div className="mr-3" onClick={() => onEdit(id)}>
            <EditPencilSvg width={15} height={15} />
          </div>
          <div className="cursor-pointer" onClick={() => toggle(id, !active)}>
            <SwitchSvg checked={active} small />
          </div>
          {/* {is_removable &&
            <div className="ml-3 cursor-pointer" onClick={() => remove(id)}>
              <TrashBinSvg width={15} height={15} />
            </div>
          } */}
        </div>
      </td>
    </Row>
  )
}